import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Wrapper, ControlsWrapper } from './SecondaryNav.styles';
import {
	ApButtonTab,
	ApButtonSecondary,
	ApSimpleDropdown,
} from '@alixpartners/ui-components';
import { Divider } from '../TaxonomyPreview.styles';

export const SecondaryNav = ({
	apTaxonomy,
	companies,
	selectedCompany,
	setSelectedCompany,
}) => {
	const [isCompaniesInDropdown, setIsCompaniesInDropdown] = useState(false);
	const history = useHistory();
	const companyDisplay =
		!apTaxonomy &&
		(isCompaniesInDropdown ? (
			<ApSimpleDropdown
				options={companies.map(company => ({
					value: company,
					label: company,
				}))}
				selected={selectedCompany}
				onChange={option => {
					setSelectedCompany(option.value);
				}}
				label={selectedCompany}
			/>
		) : (
			companies.map(company => (
				<ApButtonTab
					key={`/${company}`}
					isSelected={selectedCompany === company}
					onClick={() => setSelectedCompany(company)}
				>
					{company}
				</ApButtonTab>
			))
		));
	return (
		<Wrapper
			innerRef={element => {
				if (element) {
					if (
						element.scrollWidth > element.offsetWidth &&
						!isCompaniesInDropdown
					) {
						setIsCompaniesInDropdown(true);
					}
				}
			}}
		>
			<ControlsWrapper>
				<ApButtonSecondary
					iconName="baseline_arrow_back"
					onClick={() => {
						const backUrl = apTaxonomy
							? '/taxonomymapper/indirect'
							: '/taxonomymapper/direct';
						history.push(backUrl);
					}}
				>
					Back to mapper
				</ApButtonSecondary>
				<Divider />
				{apTaxonomy ? 'AlixPartners company' : companyDisplay}
			</ControlsWrapper>
		</Wrapper>
	);
};

export default SecondaryNav;
